<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center"
          primary-title
        >
          Start Interest Calculation
        </v-card-title>

        <v-card-text light>
          <p><strong>Description</strong>: <code>{{ payout.description }}</code></p>
          <p><strong>Payout ID</strong>: <code>{{ payout.payout_id }}</code></p>
          <p><v-divider /></p>
          <p>Are you sure you want to start the interest calculation for the payout?</p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="isVisible = false"
          >
            cancel
          </v-btn>
          <v-btn
            color="warning"
            flat
            @click="() => { isVisible = false; $emit('submit') }"
          >
            <v-icon>sync</v-icon>
            Start
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'StartInterestCalculationDialog',
  components: {
  },
  props: {
    visible: Boolean,
    payout: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>
<style lang="scss" />



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/payout/StartInterestCalculationDialog.vue